import { render, staticRenderFns } from "./InformationManager.vue?vue&type=template&id=ebf52b42&scoped=true"
import script from "./InformationManager.vue?vue&type=script&lang=js"
export * from "./InformationManager.vue?vue&type=script&lang=js"
import style0 from "./InformationManager.vue?vue&type=style&index=0&id=ebf52b42&prod&lang=css"
import style1 from "./InformationManager.vue?vue&type=style&index=1&id=ebf52b42&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebf52b42",
  null
  
)

export default component.exports